module.exports = __webpack_public_path__ + "img/amsterdam2.2d18cdb5.jpg";